<div id="wrapper">
    <app-sidebar></app-sidebar>
    <div id="content-wrapper" class="d-flex flex-column">
      <app-header class="dialog-nav"></app-header>
      <div class="container-fluid container-fullheight main-content">
        <router-outlet></router-outlet>
      </div>
    </div>
</div>